import { useLocation, Navigate } from "react-router-dom";
import { useAuthContext } from "../AuthProvider";
function RequireAuth({ children }) {
  const user = useAuthContext();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/" state={{ from: location }} />;
  }
  if (!user.name) {
    return <Navigate to="/profile" state={{ from: location }} />;
  }

  return children;
}

export default RequireAuth;
